<template>
  <div id="pagination">
    <v-pagination
      v-model="pageDirty"
      :length="lastPage"
      :total-visible="totalVisible"
    />
  </div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    value: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      required: true
    },
    totalVisible: {
      type: Number,
      default: 6
    }
  },
  computed: {
    pageDirty: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
